<template>
  <div>
    <div
      v-for="(searchItems, parentIndex) in searchList"
      :key="parentIndex"
      class="my-2 truncate-2-line search-item"
    >
      <v-tooltip bottom max-width="320px">
        <div>
          <v-chip
            v-for="searchItem in searchItems"
            class="mr-2 mb-2 caption"
            :title="searchItem.val"
            :color="'#fff'"
            :key="searchItem.id"
          >
            {{ truncate(searchItem.val, 40) }}
          </v-chip>
        </div>
        <template v-slot:activator="{ on, attrs }">
          <div
            class="mt-2"
            v-bind="attrs"
            v-on="on"
            @click="onSearchItemClick(parentIndex)"
          >
            <v-chip
              v-for="searchItem in searchItems"
              class="mr-2 mb-2 caption"
              :title="searchItem.val"
              :color="'#fff'"
              :key="searchItem.id"
            >
              {{ truncate(searchItem.val, 40) }}
            </v-chip>
          </div>
        </template>
      </v-tooltip>
    </div>
  </div>
</template>
<script>
export default {
  props: ['searchList'],
  methods: {
    onSearchItemClick(itemIndex) {
      this.$emit('searchItemClicked', itemIndex);
    }
  }
};
</script>
<style scoped>
.v-icon {
  cursor: pointer;
}
.v-chip.v-size--default {
  border-radius: 4px;
  height: auto;
}
.v-tooltip__content {
  background-color: #1b2342 !important;
  padding: 8px !important;
}
.search-item {
  border-bottom: 0.5px solid #fff;
}
</style>
